import {
  IQ_SEVERITY_LEVELS,
  type IqSeverityLevel,
} from 'src/app/shared/constants/iq-observation-action-labels';

/** @see IQ_SEVERITY_LEVELS */
export const SeverityLevels = IQ_SEVERITY_LEVELS;

export type SeverityLevel = IqSeverityLevel;

// Shared IQ observation shapes — single source of truth (do not duplicate).
export type {
  DeviceEvent,
  AccountDeviceData,
} from 'src/app/shared/types/iq-observation.model';

export interface UnusualNetworkMetrics {
  edgeName: string;
  interfaceName: string;
  timestamp: string;
  bandwidth: number;
  latency: number;
  jitter: number;
  packetloss: number;
  bucket: string;
  datausage: number;
  anomalies: string;
}
